import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { identityServices } from '../identityServices'
import { UpdatePasswordPayload } from '../identityTypes'

import { ErrorDetail, IOptionsUseMutation } from '@/api/apiTypes'

export function useUpdatePassword(options?: IOptionsUseMutation<string>) {
  const { t } = useTranslation()

  const mutation = useMutation<unknown, ErrorDetail, UpdatePasswordPayload>({
    mutationFn: (data) => identityServices.updatePassword(data),
    onSuccess: () => {
      if (options?.onSuccess) {
        options.onSuccess(t('form:success.changesSaved'))
      }
    },
    onError: (err) => {
      if (options?.onError)
        options?.onError({
          ...err,
          errorMessage: t('api:errors.somethingWrong'),
        })
    },
  })

  async function updatePassword(data: UpdatePasswordPayload) {
    mutation.mutate(data)
  }

  return {
    updatePassword,
    ...mutation,
  }
}
